import { PlanningMeasurementRequest } from "@/types/planning";
import { UniqueIdentifier } from "@dnd-kit/core";

export const isWaferRequest = (id: UniqueIdentifier): boolean => {
  return id.toString().startsWith("WaferRequest");
};

export const flattenWaferRequests = (
  rows: PlanningMeasurementRequest[],
): Record<number, number[]> => {
  return rows.reduce(
    (acc, cur) => {
      if (!acc[cur.id]) {
        acc[cur.id] = cur.waferRequests.map((w) => w._id);
      }

      return acc;
    },
    {} as Record<number, number[]>,
  );
};
